import { Link, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { miniApp } from '@telegram-apps/sdk';
import { useNavigate, useLocation } from 'react-router-dom';

export const PaymentConfirm = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    const handlePageHide = () => {
      console.log('Page is redirecting, closing Mini App...');
      window.Telegram?.WebApp.close();
      miniApp.close();
    };
    window.addEventListener('pagehide', handlePageHide);

    return () => {
      window.removeEventListener('pagehide', handlePageHide);
    };
  }, []);
  const orderParam = searchParams.get('orderId');
  const language = searchParams.get('language');
  const insuranceType = searchParams.get('insuranceType');
  return (
    <>
      <p>payment-confirm</p>
      <p>{`${miniApp.isMounted}`}</p>
      <iframe
        title="payment"
        src={`${process.env.REACT_APP_NEXT_PUBLIC_HOST_FUNCTION}/maibData?language=${language}&orderId=${orderParam}&insuranceType=${insuranceType}&isTelegram=true`}
        style={{
          width: '100%',
          height: '100vh',
          zIndex: '3',
          position: 'relative',
        }}
      />
    </>
  );
};
